import { CombinedGraphQLErrors } from "@apollo/client/errors";
import {
  FORMULA_GRAMMAR_INVALID,
  FORMULA_UNKNOWN_VARIABLE,
} from "./formulaErrorCodes";
import type { FormulaValidationError } from "./validateFormula";

// Maps a backend rejection to the inline validator's shape so it renders
// identically (BDTS-1998 contract). Returns null for non-formula errors (e.g.
// STALE_VERSION, network), handled elsewhere.
export function mapBackendError(error: unknown): FormulaValidationError | null {
  if (!CombinedGraphQLErrors.is(error)) return null;
  for (const e of error.errors) {
    const code = e.extensions?.code;
    if (code === FORMULA_GRAMMAR_INVALID) {
      const offset = e.extensions?.offset;
      return {
        code: FORMULA_GRAMMAR_INVALID,
        ...(typeof offset === "number" ? { offset } : {}),
      };
    }
    if (code === FORMULA_UNKNOWN_VARIABLE) {
      return {
        code: FORMULA_UNKNOWN_VARIABLE,
        unknownCode: String(e.extensions?.unknownCode ?? ""),
        availableCodes: Array.isArray(e.extensions?.availableCodes)
          ? (e.extensions.availableCodes as string[])
          : [],
      };
    }
  }
  return null;
}
